/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_InternshipsInputs */

const cs_nav_internships = /** @type {(inputs: Nav_InternshipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stáže`)
};

const sk_nav_internships = /** @type {(inputs: Nav_InternshipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stáže`)
};

const en_nav_internships = /** @type {(inputs: Nav_InternshipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internships`)
};

/**
* | output |
* | --- |
* | "Internships" |
*
* @param {Nav_InternshipsInputs} inputs
* @param {{ locale?: "cs" | "sk" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_internships = /** @type {((inputs?: Nav_InternshipsInputs, options?: { locale?: "cs" | "sk" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_InternshipsInputs, { locale?: "cs" | "sk" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "cs") return cs_nav_internships(inputs)
	if (locale === "sk") return sk_nav_internships(inputs)
	return en_nav_internships(inputs)
});